import api from '../Services/AxiosInstance';

export class UserService {

    connectUser(user) {

        return api.post("User/Connect", user,
            {
                Headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(user)
            }).then(res => res.data)


    };
}